export default __webpack_public_path__ + "static/vedicSrijan-8830fdfb1fbf407bf957587b581de62b.jpg";